module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES72UC4']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codrel))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.namsick))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_codcln))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_coddc))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_typpatient))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.desc_typamt))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgdocmt),
      expression: "detail.tab1.flgdocmt"
    }],
    attrs: {
      "type": "radio",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgdocmt, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgdocmt", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['110']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.flgdocmt),
      expression: "detail.tab1.flgdocmt"
    }],
    attrs: {
      "type": "radio",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.flgdocmt, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "flgdocmt", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['120']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam1,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam1))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam2,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseURL + _vm.detail.tab1.path_filenam3,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.detail.tab1.filenam3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['160']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.amtreq))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.tab1.dtecrest)) + " - " + _vm._s(_vm.setDateOutput(_vm.detail.tab1.dtecreen)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['180']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.qtydte))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.typpay),
      expression: "detail.tab1.typpay"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.typpay, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "typpay", "1")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['200']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.typpay),
      expression: "detail.tab1.typpay"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab1.typpay, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab1, "typpay", "2")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['210']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC4']['220']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab1.remarkap))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES72UC0']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.tab2Table,
      "data": _vm.detail.tab2.table,
      "columnEvent": _vm.columnEvent,
      "summaryLabel": _vm.labels['HRES72UC0']['70']
    }
  }), _vm._v(" "), _c('input', {
    ref: "popup",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres72u-popup",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popupDisp),
      expression: "popupDisp"
    }],
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "detailTab2Popup": _vm.detailTab2Popup
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES72UC5']['0']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "details3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70 txtarea-width response-full-width"
  }, [_vm._v(_vm._s(_vm.detail.tab3.syncond))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.flgprorate),
      expression: "detail.tab3.flgprorate"
    }],
    attrs: {
      "type": "radio",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab3.flgprorate, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab3, "flgprorate", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['30']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab3.flgprorate),
      expression: "detail.tab3.flgprorate"
    }],
    attrs: {
      "type": "radio",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.tab3.flgprorate, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail.tab3, "flgprorate", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['40']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.desc_typamt))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.amtwidrwy))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.qtysum))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.amtalw))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.qtywidrwy))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES72UC5']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70"
  }, [_vm._v(_vm._s(_vm.detail.tab3.amtwidrwt))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d6f3eb96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres72u/detail.vue
// module id = 3988
// module chunks = 1